export const getRiskLabel = (riskScore) => {
  if (riskScore < 0.33) {
    return 'LOW_RISK';
  }
  if (riskScore < 0.66) {
    return 'MEDIUM_RISK';
  }
  return 'HIGH_RISK';
};
